<template>
  <bar-chart :chart-data="chartData"/>
</template>

<script>
  import BarChart from "@view/components/chart/BarChart"
  export default {
    name: "DeviceModelCount",
    components: {BarChart},
    data() {
      return {
        chartData: {
          title: "月收支统计",
          label: [],
          showLegend: true,
          barList: [
            {name: "收入", color: "#0CCA8E", data:[]},
            {name: "支出", color: "#F1635F", data:[]},
          ]
        }
      }
    },
    created() {
      this.getData();
    },
    methods: {
      async getData() {
        let res = await this.$Http.getBillMonth();
        if (res?.data) {
          let obj = res.data || {};
          this.chartData.label = Object.keys(obj).reverse();
          let incomeList = [];
          let expenseList = [];
          Object.values(obj).reverse().forEach(item => {
            incomeList.push(this.convertYuan(item[0].total_income));
            expenseList.push(this.convertYuan(item[0].total_expense));
          });
          this.chartData.barList[0].data = incomeList;
          this.chartData.barList[1].data = expenseList;
        }
      }
    }
  }
</script>

<style scoped>

</style>
